module.exports = __webpack_public_path__ + "img/logo.cb8384b6.png";